import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconEuro = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'M15.955 21.499h7.128a.5.5 0 1 1 0 1H15.72c-.087.488-.14.988-.14 1.5 0 .514.053 1.014.14 1.502h7.364a.5.5 0 1 1 0 1h-7.128c1.07 3.473 4.31 6.004 8.13 6.004 1.69 0 3.325-.495 4.724-1.432a.501.501 0 0 1 .557.832 9.47 9.47 0 0 1-5.282 1.6c-4.374 0-8.058-2.974-9.16-7.004h-2.847a.5.5 0 1 1 0-1h2.632a9.5 9.5 0 0 1-.13-1.501c0-.512.052-1.01.13-1.501h-2.632a.5.5 0 1 1 0-1h2.847c1.102-4.03 4.786-7.004 9.16-7.004 1.89 0 3.716.553 5.282 1.6a.5.5 0 1 1-.557.832 8.46 8.46 0 0 0-4.725-1.432c-3.82 0-7.058 2.53-8.13 6.004M40.97 40.971c-9.373 9.372-24.569 9.372-33.942 0s-9.372-24.569 0-33.942c9.373-9.372 24.569-9.372 33.942 0s9.372 24.569 0 33.942m-1.458-16.978c0-.504-.028-1.002-.075-1.494h-4.592a.5.5 0 1 1 0-1h4.449c-1.196-7.388-7.586-13.035-15.31-13.035-8.578 0-15.53 6.953-15.53 15.53s6.952 15.529 15.53 15.529c7.72 0 14.106-5.64 15.308-13.022h-4.447a.5.5 0 1 1 0-1h4.591q.074-.744.076-1.508',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconEuro)
export default ForwardRef
